







































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRouterLink
  }
})
export default class extends Mixins(Common) {
  @Prop(String) readonly feedId!: string
  @Prop(Object) readonly thumbnail!: object

  @Prop(String) readonly text!: string
  @Prop(String) readonly belowText!: string
  @Prop(Number) readonly views!: number
  @Prop(String) readonly itemUrl!: string | null
  @Prop(Number) readonly itemCount!: number
  @Prop(String) readonly profileUrl!: string
  @Prop(Number) readonly saveCount!: number
  @Prop(Number) readonly spanCount!: number

  isVisible = false

  mediaVisibilityChanged (isVisible: boolean) {
    this.isVisible = isVisible
  }
}
